var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelicopter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 126.96,
    className: "st0",
    width: 158.043,
    height: 19.222
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.737,
    y: 126.96,
    className: "st0",
    width: 158.036,
    height: 19.222
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510.934,123.949c-1.102-1.556-2.87-2.479-4.772-2.479h-31.245c-8.026,0-15.481,4.125-19.76,10.908 l-34.076,54.13c-3.561,5.656-9.781,9.09-16.468,9.09H190.812V126.96h-17.845v68.639h-28.67c-20.888,0-40.378,10.478-51.908,27.895 l-60.805,91.844c-9.844,14.88-10.716,33.961-2.28,49.673c8.442,15.712,24.839,25.518,42.678,25.518h159.26 c13.854,0,26.658-7.366,33.627-19.331l46.105-79.176c3.645-6.27,9.999-10.485,17.192-11.414l121.271-14.54 c8.718-1.128,16.064-7.052,19.004-15.334l43.223-121.469C512.298,127.478,512.023,125.493,510.934,123.949z M176.644,302.586 H70.112l42.198-63.745c7.046-10.646,18.876-17.006,31.642-17.006h32.692V302.586z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelicopter);
export default __webpack_public_path__ + "static/media/helicopter.64e5c3723063e9691c38b3f3eb80bcb3.svg";
export { ForwardRef as ReactComponent };